export default function Blog() {
  const blogPosts = [
    {
      title: "The Future of Legal Tech: AI-Powered Solutions",
      date: "March 2024",
      category: "Legal Technology",
      excerpt: "Exploring how artificial intelligence is revolutionizing the legal industry and transforming traditional law practices.",
      image: "https://public.readdy.ai/ai/img_res/df7d4f76131391e8a10ef2a88f87ea8a.jpg"
    },
    {
      title: "Corporate Law in Egypt: A Complete Guide for Foreign Investors",
      date: "February 2024",
      category: "Corporate Law",
      excerpt: "Everything you need to know about establishing and operating a business in Egypt, from registration to compliance.",
      image: "https://readdy.ai/api/search-image?query=egyptian%20business%20district%20modern%20corporate%20buildings%20cairo%20skyline%20professional%20business%20environment%20golden%20hour%20lighting%20clean%20background&width=800&height=500&seq=blog002&orientation=landscape"
    },
    {
      title: "Understanding Investment Law: Protections and Guarantees",
      date: "February 2024",
      category: "Investment Law",
      excerpt: "A comprehensive overview of investment protections, guarantees against nationalization, and legal frameworks in Egypt.",
      image: "https://readdy.ai/api/search-image?query=investment%20protection%20legal%20documents%20handshake%20business%20agreement%20professional%20setting%20modern%20office%20clean%20background&width=800&height=500&seq=blog003&orientation=landscape"
    },
    {
      title: "Employment Law Essentials: Rights and Obligations",
      date: "January 2024",
      category: "Employment Law",
      excerpt: "Navigate the complexities of Egyptian employment law with our guide to employee rights, contracts, and dispute resolution.",
      image: "https://readdy.ai/api/search-image?query=diverse%20professional%20team%20modern%20office%20workplace%20collaboration%20business%20meeting%20natural%20lighting%20clean%20background&width=800&height=500&seq=blog004&orientation=landscape"
    },
    {
      title: "Real Estate Transactions: Legal Considerations",
      date: "January 2024",
      category: "Real Estate Law",
      excerpt: "Key legal aspects of buying, selling, and leasing property in Egypt for foreign investors and businesses.",
      image: "https://readdy.ai/api/search-image?query=modern%20real%20estate%20property%20luxury%20building%20architecture%20professional%20photography%20blue%20sky%20clean%20background&width=800&height=500&seq=blog005&orientation=landscape"
    },
    {
      title: "Mergers & Acquisitions: Strategic Legal Planning",
      date: "December 2023",
      category: "M&A",
      excerpt: "Expert insights on structuring successful M&A transactions, due diligence, and regulatory compliance in Egypt.",
      image: "https://readdy.ai/api/search-image?query=business%20merger%20handshake%20corporate%20meeting%20professional%20executives%20modern%20boardroom%20natural%20lighting%20clean%20background&width=800&height=500&seq=blog006&orientation=landscape"
    },
    {
      title: "Intellectual Property Protection in the Digital Age",
      date: "December 2023",
      category: "IP Law",
      excerpt: "Safeguarding your intellectual property rights in an increasingly digital business landscape.",
      image: "https://readdy.ai/api/search-image?query=intellectual%20property%20digital%20innovation%20technology%20patents%20trademarks%20modern%20design%20blue%20tones%20clean%20background&width=800&height=500&seq=blog007&orientation=landscape"
    },
    {
      title: "Contract Law: Drafting Effective Business Agreements",
      date: "November 2023",
      category: "Contract Law",
      excerpt: "Best practices for creating legally sound contracts that protect your business interests and minimize disputes.",
      image: "https://readdy.ai/api/search-image?query=business%20contract%20signing%20legal%20documents%20professional%20hands%20pen%20modern%20office%20desk%20clean%20background&width=800&height=500&seq=blog008&orientation=landscape"
    },
    {
      title: "Tax Law Updates: What Businesses Need to Know",
      date: "November 2023",
      category: "Tax Law",
      excerpt: "Recent changes in Egyptian tax legislation and their implications for foreign-owned businesses.",
      image: "https://readdy.ai/api/search-image?query=tax%20planning%20financial%20documents%20calculator%20business%20accounting%20professional%20desk%20organized%20workspace%20clean%20background&width=800&height=500&seq=blog009&orientation=landscape"
    },
    {
      title: "Dispute Resolution: Arbitration vs. Litigation",
      date: "October 2023",
      category: "Dispute Resolution",
      excerpt: "Comparing different approaches to resolving business disputes and choosing the right strategy for your case.",
      image: "https://readdy.ai/api/search-image?query=legal%20dispute%20resolution%20mediation%20professional%20meeting%20business%20negotiation%20modern%20conference%20room%20clean%20background&width=800&height=500&seq=blog010&orientation=landscape"
    },
    {
      title: "Compliance and Regulatory Framework in Egypt",
      date: "October 2023",
      category: "Compliance",
      excerpt: "Understanding the regulatory landscape and maintaining compliance with Egyptian business laws and regulations.",
      image: "https://readdy.ai/api/search-image?query=regulatory%20compliance%20checklist%20business%20standards%20professional%20documentation%20modern%20office%20clean%20background&width=800&height=500&seq=blog011&orientation=landscape"
    },
    {
      title: "Cross-Border Transactions: Legal Considerations",
      date: "September 2023",
      category: "International Law",
      excerpt: "Navigating the legal complexities of international business transactions and cross-border investments.",
      image: "https://readdy.ai/api/search-image?query=international%20business%20global%20trade%20world%20map%20connections%20professional%20modern%20design%20blue%20tones%20clean%20background&width=800&height=500&seq=blog012&orientation=landscape"
    }
  ];

  return (
    <div className="min-h-screen bg-[#E8E4DC] font-mono">
      {/* Background Effects */}
      <div className="fixed inset-0 opacity-[0.03] pointer-events-none"></div>
      <div className="fixed inset-0 opacity-[0.08] pointer-events-none">
        <div className="absolute top-[-10%] left-[-5%] w-[600px] h-[600px] rounded-[40%_60%_70%_30%/60%_30%_70%_40%] bg-gradient-radial from-[#4A4A4A] via-[#6A6A6A] to-[#8A8A8A] blur-[100px] animate-pulse"></div>
        <div className="absolute top-[10%] right-[-10%] w-[550px] h-[550px] rounded-[60%_40%_30%_70%/40%_60%_70%_30%] bg-gradient-radial from-[#5A5A5A] via-[#7A7A7A] to-[#4A4A4A] blur-[100px] animate-pulse"></div>
      </div>

      <div className="relative">
        {/* Header */}
        <header className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-6">
          <div className="max-w-[1200px] mx-auto flex justify-between items-center">
            <a href="/" className="text-2xl font-black text-[#4A4A4A] hover:text-amber-600 transition-colors cursor-pointer">
              ← BACK TO HOME
            </a>
          </div>
        </header>

        {/* Hero Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto text-center">
            <h1 className="text-[64px] md:text-[96px] font-black leading-none tracking-tight text-[#4A4A4A] mb-6">
              BLOG POSTS
            </h1>
            <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
              <div className="h-[1px]"></div>
            </div>
            <p className="text-xl text-[#4A4A4A] max-w-[800px] mx-auto">
              Insights, updates, and expert analysis on legal matters affecting businesses in Egypt
            </p>
          </div>
        </section>

        {/* Blog Grid */}
        <section className="px-6 py-16">
          <div className="max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts.map((post, index) => (
                <article key={index} className="bg-white/60 border-4 border-dashed border-[#4A4A4A] overflow-hidden hover:border-amber-600 transition-colors group">
                  <div className="relative h-[250px] overflow-hidden">
                    <img 
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-amber-600 text-white px-3 py-1 text-xs font-bold border-2 border-dashed border-[#4A4A4A]">
                        {post.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <i className="ri-calendar-line text-[#4A4A4A]"></i>
                      <span className="text-sm text-[#4A4A4A]">{post.date}</span>
                    </div>
                    <h2 className="text-xl font-black text-[#4A4A4A] mb-3 group-hover:text-amber-600 transition-colors">
                      {post.title}
                    </h2>
                    <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                      {post.excerpt}
                    </p>
                    <button className="inline-flex items-center gap-2 text-sm font-bold text-amber-600 hover:text-[#4A4A4A] transition-colors cursor-pointer whitespace-nowrap">
                      READ MORE <i className="ri-arrow-right-line"></i>
                    </button>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="border-t-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-amber-600/90 to-amber-700/90">
          <div className="max-w-[900px] mx-auto text-center">
            <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-white mb-6">
              NEED LEGAL ADVICE?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-[700px] mx-auto">
              Contact us today to discuss your legal needs with our expert team
            </p>
            <a href="mailto:elhawarybrothersllc@gmail.com" className="inline-block bg-white text-amber-600 px-8 py-4 text-lg font-bold border-2 border-dashed border-white hover:bg-amber-100 transition-colors whitespace-nowrap cursor-pointer">
              CONTACT US TODAY
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="px-6 py-12 bg-stone-800 text-stone-200">
          <div className="max-w-[1200px] mx-auto text-center">
            <p className="text-stone-400 text-sm">© 2025 Elhawary Brothers LLC. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </div>
  );
}
